<div [class.has-error]="!valid" [class.has-success]="valid && modified">
    <input type="text" size="5" [(ngModel)]="inputText" (blur)="focusLost()" (keyup)="change()" (change)="change()" (keypress)="keyPressed($event)" />
</div>
